import { render, staticRenderFns } from "./ArrowShort.vue?vue&type=template&id=23573d3b&"
import script from "./ArrowShort.vue?vue&type=script&lang=js&"
export * from "./ArrowShort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports